export default { sha: '06b7156b744f00d310a0e7dd2a393db1a5109387', buildNumber: 'undefined' }
